import {
  ACCESS,
  AGENT_TOOLS,
  LICENSES,
  LOGS,
  MY_ACCOUNT,
  SETTINGS,
  STATUS,
  renderLinkTo,
  routeLabels
} from '@eggplant/routing'
import { DaiAccessControl } from '@eggplant/context'
import {
  FaCogs,
  FaFileDownload,
  FaIdCard,
  FaKey,
  FaThermometerHalf,
  FaUserCircle,
  FaWrench
} from 'react-icons/fa'
import { NavItemVerticalMini } from '@eggplant/pattern-library'

interface Props {
  base: string
  isCollapsed: boolean
}

const SystemNav = ({
  base,
  isCollapsed
}: Props) =>
  <>
    <NavItemVerticalMini
      icon={<FaThermometerHalf aria-hidden />}
      isCollapsed={isCollapsed}
      label={routeLabels[STATUS]}
    >
      {renderLinkTo(base + '/' + STATUS)}
    </NavItemVerticalMini>
    <DaiAccessControl isHiddenIfDenied>
      <NavItemVerticalMini
        icon={<FaKey aria-hidden />}
        isCollapsed={isCollapsed}
        label={routeLabels[ACCESS]}
      >
        {renderLinkTo(base + '/' + ACCESS)}
      </NavItemVerticalMini>
    </DaiAccessControl>
    <NavItemVerticalMini
      icon={<FaUserCircle aria-hidden />}
      isCollapsed={isCollapsed}
      label={routeLabels[MY_ACCOUNT]}
    >
      {renderLinkTo(base + '/' + MY_ACCOUNT)}
    </NavItemVerticalMini>
    <DaiAccessControl isHiddenIfDenied>
      <NavItemVerticalMini
        icon={<FaFileDownload aria-hidden />}
        isCollapsed={isCollapsed}
        label={routeLabels[LOGS]}
      >
        {renderLinkTo(base + '/' + LOGS)}
      </NavItemVerticalMini>
    </DaiAccessControl>
    <DaiAccessControl isHiddenIfDenied>
      <NavItemVerticalMini
        icon={<FaIdCard aria-hidden />}
        isCollapsed={isCollapsed}
        label={routeLabels[LICENSES]}
      >
        {renderLinkTo(base + '/' + LICENSES)}
      </NavItemVerticalMini>
    </DaiAccessControl>
    <DaiAccessControl isHiddenIfDenied>
      <NavItemVerticalMini
        icon={<FaWrench aria-hidden />}
        isCollapsed={isCollapsed}
        label={routeLabels[AGENT_TOOLS]}
      >
        {renderLinkTo(base + '/' + AGENT_TOOLS)}
      </NavItemVerticalMini>
    </DaiAccessControl>
    <NavItemVerticalMini
      icon={<FaCogs aria-hidden />}
      isCollapsed={isCollapsed}
      label={routeLabels[SETTINGS]}
    >
      {renderLinkTo(base + '/' + SETTINGS)}
    </NavItemVerticalMini>
  </>

export default SystemNav
